import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from "@angular/core";
import { KreFormFieldConfig } from "@kre-form/core";
import * as _ from "lodash";
import { DataService } from "../../service/data.service";

import { ITreeData, ICheckedTree } from "../../tools/util";

@Component({
  selector: "kreform-postion",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"],
  providers: [DataService]
})
export class KreFormPostion implements OnInit {
  @Input() fieldConfig: KreFormFieldConfig = {};
  @Input() tag: boolean = false;
  @Output() treeChangeEvent = new EventEmitter<any>();

  treeData: ITreeData[] = [];

  controlid: string = "";
  orgid:string ="";

  selectData: ICheckedTree[] = [];
   
  //选择节点
  get selectedNode() {
    return _.cloneDeep(this.selectData);
  }
 

  constructor(public dataService: DataService) {}

  ngOnInit() { 
    this.getOrgData(); 
    this.action = 2;
    if (this.selectType == "multiple") {
      this.check = true;
      this.action = 0;
    }
    if (this.selectType == "single") {
      this.check = false;
      this.action = 2;
      this.header.push(
        { "key": "action", "name": "操作", "hiden": true, "action": true }
      );
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.defaultNode) {
    }
  }

  //获取Org数据集
  getOrgData() {
    this.dataService.getTreeData({ id: this.controlid }).subscribe(res => {
      this.treeData = res;  
      this.getSelectData();
    });
  } 

  ////
  //是否要多选
  check = false;

  //是否有操作列0 没有操作列；1 多个操作按钮 2 选择
  action = 0;

  //table 头部信息
  header: any[] = [
    { "key": "id", "name": "id", "hiden": true },
    { "key": "code", "name": "职位编码", "width": 100 },
    { "key": "name", "name": "职位名称", "width": 150 },
    { "key": "number", "name": "在职人数", "width": 80  },
    { "key": "parent", "name": "上级职位" }
  ];

  //table 行数据
  body: any[] = [];

  buttonlist: any[] = [];

  checkid: any[] = [];

  query = {
    total: 0,
    pageIndex: 1,
    pageSize: 15,
    sortName: "",
    sortValue: "",
    keyWord: ""
  }
 
  get selectType() {
    let res = "";
    if (
      this.fieldConfig != undefined &&
      this.fieldConfig != null &&
      this.fieldConfig.templateOptions != undefined &&
      this.fieldConfig.templateOptions != null &&
      this.fieldConfig.templateOptions.selectType != undefined
    ) {
      res = this.fieldConfig.templateOptions.selectType;
    }
    return res;
  }

  getSelectData() {
    if (
      this.fieldConfig != null &&
      this.fieldConfig.model != undefined &&
      this.fieldConfig.model != null &&
      this.fieldConfig.key != undefined &&
      this.fieldConfig.key != null &&
      this.fieldConfig.model[this.fieldConfig.key] != undefined &&
      this.fieldConfig.model[this.fieldConfig.key] != null
    ) {
      this.selectData = _.cloneDeep(
        this.fieldConfig.model[this.fieldConfig.key]
      );
    }
 
    if(this.selectData!=null && this.selectData.length>0){
      this.checkid =this.selectData.map(item=>{
        return {
          "id":item.value,
          "name":item.label
        }
      });
    }else{
      this.checkid=[];
    }
  }

 
  getPostionData() {
    this.dataService.getSysCtrPostionTable(
      {
        keyWord: this.query.keyWord,
        pageIndex: this.query.pageIndex,
        pageSize: this.query.pageSize
      }
    ).subscribe((res: any) => {
      this.query.pageIndex = res.index;
      this.query.total = res.total;
      this.body = res.data;
    });

    this.getSelectData();
  }

  pageIndexChange(event: any) {
    this.dataService.getSysCtrPostionTable(
      {
        keyWord: this.query.keyWord,
        pageIndex: this.query.pageIndex,
        pageSize: this.query.pageSize
      }).subscribe((res: any) => { 
        this.query.pageIndex = event.pageIndex;
        this.query.total = res.total;
        this.body = res.data;
      });
  }

  checkChange(list: any[]) {
    if (list != null && list.length > 0) {
      this.selectData = list.map(item => {
        return {
          "label": item.name, "value": item.id
        }
      });
    } else {
      this.selectData = [];
    }
  }

  orgChange(event:any){ 
    if(event!=null && event!=undefined && event.checkData!=undefined && event.checkData.length>0){
      this.orgid = event.checkData[0].value;
      this.getPostionData();
    }
  }
}
